<template>
<!-- Note: fields should be 48px heigh normally, or 32px when small height -->

<div :class="fieldOuterClass" :style="fieldOuterStyle" v-if="visible">
<div v-if="field.clickToEdit && !editing" :style="fieldStyle" :class="fieldClass" style="display:flex">
    <div class="grey--text text--darken-2" v-html="htmlValue" :hide-details="hideDetails" />
    <v-btn @click="startEditing" small text icon color="grey" style="margin-top:-5px"><v-icon small>edit</v-icon></v-btn>      
</div>        

<div v-else :style="fieldStyle" :class="fieldClass" @click="fieldClicked">
    <template v-if="field.type == 'Text'">
        <v-textarea v-if="field.rows" v-model="value" @change="changed" @blur="blurred" :rows="field.rows" :label="field.title" :disabled="disabled" :hide-details="hideDetails" :single-line="singleLine" :autofocus="field.focus" :clearable="field.clearable" />        
        <v-text-field v-else v-model="value" @change="changed" @blur="blurred" :label="field.title" :disabled="disabled" :hide-details="hideDetails" :single-line="singleLine" :autofocus="field.focus" :clearable="field.clearable" />        
    </template>
    <template v-if="field.type == 'List'">
        <v-select v-model="record[field.name]" :items="options" :label="field.title" :disabled="disabled" :hide-details="hideDetails" :single-line="singleLine" :multiple="field.multiple" :chips="field.multiple" :return-object="field.returnObject" />        
    </template>
    <template v-if="field.type == 'Checkbox'">
        <v-checkbox v-model="record[field.name]" :label="field.title" :disabled="disabled" :hide-details="hideDetails" color="primary" />        
    </template>
    <template v-if="field.type == 'Date'">
        <DateTime date-only v-model="record[field.name]" :label="field.title" :disabled="disabled" :hide-details="hideDetails" />        
    </template>
    <template v-if="field.type == 'Options'">
        <v-radio-group v-model="record[field.name]" :label="field.title" :disabled="disabled" :hide-details="hideDetails" color="primary">
            <v-radio v-for="(item, index) in options" :key="index">{{item}}</v-radio>
        </v-radio-group>            
    </template>
    <template v-if="field.type == 'Switch'">
        <v-switch v-model="record[field.name]" :label="field.title" :disabled="disabled" :hide-details="hideDetails" color="primary" />        
    </template>
    <template v-if="field.type == 'Html'">
        <div class="grey--text text--darken-2" v-html="htmlValue" :hide-details="hideDetails" />      
    </template>
    <template v-if="field.type == 'Button'">
        <v-btn @click="$emit('button', field)" :color="field.color" style="margin-top:12px;margin-bottom:0px;width:100%">{{field.title}}</v-btn>      
    </template>

    <template v-if="field.type == 'File'">
        <FileField :record="record" :field="field" />        
    </template>

    <template v-if="field.type == 'Embed'"> 
        <!-- See mounted for loading code -->
        <div ref="embedded"></div>
        <div v-if="!field.disabled" class="pt-2">

            <v-text-field label="Link to information" v-model="record[field.name]" />
        </div>
    </template>

    <template v-if="field.type == 'Group' && isGroupVisible(field, record)">
        <div class="section-heading vertical-margin">{{field.title}}</div>
        <div v-if="!record[field.name] || record[field.name].length < 1">
            No records exist. <a href @click.prevent="createAndPush">Create</a>
        </div>
        <div v-for="(subRecord, subRecordIndex) in record[field.name]" :key="subRecordIndex" style="border-left:solid 5px #ddd;margin-bottom:10px;">
            <div style="display:flex; flex-wrap:wrap;width:100%" >
                <InterfaceField v-for="(subField, index) in field.fields" :field="subField" :settings="settings" :record="subRecord" :key="index" />
            </div> 
            <div style="float:right;margin-top:-33px;" v-if="!field.disabled">

            <v-menu offset-y left>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">keyboard_arrow_down</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="createAndPush">
                        <v-list-item-title>Add Another</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="record[field.name].splice(subRecordIndex, 1)">
                        <v-list-item-title>Delete Item</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>  
            </div>
        </div>
    </template>

    <template v-if="!field || !field.type">
        <div>MISSING FIELD DEFINITION</div>
    </template>
</div>
</div>

</template>

<script>
import DateTime from '../ui-elements/DateTime'
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import FileField from './FileField'
import MergeHelpers from '../helpers/MergeHelpers';
import NiceData from '../data/NiceData';


export default {
    data() {
        return {
            editing: false
        }
    },

    components: {
        FileField,
        DateTime,
    },
    
    props: {
        field: {
            default: () => {return {}} ,
            type: Object
        },
        record: Object,
        settings: {
            type: Object,
            default: () => {return {}}, 
        },
    },

    computed: {
        options() {
            if(!this.field.options)
                return []
            if(Array.isArray(this.field.options))
                return this.field.options

            return (this.field.options || String('')).split(',').map(s => s.trim())
        },

        value: {
            get() {
                return this.record[this.field.name]
            },
            set(newVal) {
                this.$set(this.record,this.field.name, newVal)
            }
            
        },

        fieldOuterStyle() {
            return {
                'width': (this.field.width || '100') + '%',
            }
        },
        fieldStyle() {
            
            let style = {
                // 'flex-grow': 1,
                'border-style': 'dashed',
                'border-width': '2px',
                'border-color': ( this.settings && this.settings.editing ? '#ddd' : 'transparent'),
                'padding': '3px',
                'border-radius': '3px',
            }
            return style
        },
        fieldClass() {
            let classString = "field-inner"
            if(this.field.compact)
                classString += ' compact'
            return classString
        },
        fieldOuterClass() {
            let classString = "field-outer"
            if(this.field.height == 'S')
                classString += ' height-small'
            return classString
        },
        disabled() {
            return this.settings.editing || this.field.disabled
        },
        hideDetails() {
            return this.field.height != 'L'
        },
        singleLine() {
            return this.field.height == 'S'
        },
        htmlValue() {
            if(this.record[this.field.name])
                return this.record[this.field.name]
            if(this.field.defaultValue)
                return this.field.defaultValue
            return '[No Value]'
        },
        visible() {
            let filter = this.field.visibleFilter
            if(filter == null)
                return true

            if(this.field.type == 'Menu')
                return false

            console.log('running visible on', this.field)

            let mergeFields = MergeHelpers.findMergeFields(filter)
            
            filter = MergeHelpers.mergeRecord(filter, mergeFields, this.record)
            console.log('expression testing on', filter)
            
            try {
                return eval(filter)
            } catch(err) {
                console.log('Error in eval: ',err, filter)
            }
        }
    },

    methods: {

        startEditing() {
            this.editing = true
        },
        finishEditing() {
            this.editing = false
        },
        isGroupVisible(field, record) {
            return (record[field.name] && record[field.name].length) ||
                !field.disabled
        },

        createAndPush() {
            if(!this.record[this.field.name])
                this.$set(this.record, this.field.name, [])
                // this.record[this.field.name] = []
            this.record[this.field.name].push({})
        },

        fieldClicked(field) {
            this.$emit('click', this.field)
        },

        changed(newVal, oldVal) {
            let changes = {
                value: newVal,
                oldValue: oldVal || null,  //text field will not show an old val
                field: this.field,
                name: this.field.name
            }
            this.$emit('change', changes)   
        },

        blurred() {
             if(this.field.clickToEdit)
                this.editing = false
        },

        updateEmbeddedInformation() {
            if(this.field.type == 'Embed') {
                let vm = this
                if(!this.value) {
                    vm.$refs.embedded.innerHTML = ''
                    return
                }
 
                fetch(this.value)
                .then(function(res) { return res.text(); })
                .then(function(data) {
                    data = data || ''
                    vm.$refs.embedded.innerHTML = data
                })
            }
        }
    },

    watch: {
        'value': function (newVal, oldVal) {
            this.$emit('input', newVal) 
            if(this.field.type != 'Text')
                this.changed(newVal, oldVal)    
            this.updateEmbeddedInformation()      
        },
        immediate: true
    },

    mounted() {
        this.updateEmbeddedInformation()
    },

    created() {
        if(this.field.clickToEdit && !this.value)
            this.editing = true
    }
}
</script>

<style scoped>

    .field-outer {padding:0px 5px;}
    .height-normal {background-color:yellow;margin-bottom:-20px}
    
    .height-small .v-text-field {padding-top:0px!important; margin-top:0px}

    .v-input--checkbox {margin-bottom:4px}
    .height-small .v-input--checkbox {margin-top:0px;}
    .text-align-right {text-align: right}
</style>




// WEBPACK FOOTER //
// InterfaceField.vue?6c441910